<template>
    <v-col cols="12">
      <v-form @submit.prevent="save" lazy-validation v-model="valid" ref="form">
        <v-card tile class="mx-1">
          <v-card-title>
            <p> {{ titulo }} </p>
          </v-card-title>
          <v-card-subtitle>
            O monitoramento é realizado para evitar erros na execução financeira dos projetos, bem como orientar a correta aplicação dos procedimentos do financiador.
            Espaço reservado para preenchimento pela Agente de M&A Financeira das informações sobre parceiro, período e relatório de monitoramento realizado.            
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="mb-n4">
                <span class="font-weight-bold text-uppercase">Projeto:</span>
                <p class="font-weight-light title ">
                  {{ prestacaoConta.projeto.titulo }}
                </p>
              </v-col>

              <v-col cols="4" class="mb-n4">
                <span class="font-weight-bold text-uppercase">Parceiro:</span>
                <p class="font-weight-light title">
                  {{ prestacaoConta.organizacao ? prestacaoConta.organizacao.nome : '' }}
                </p>
              </v-col>
              <v-col cols="4" class="mb-n4">
                <span class="font-weight-bold text-uppercase">Responsável:</span>
                <p class="font-weight-light title ">
                  {{ usuario.nome }}
                </p>
              </v-col>
              <v-col cols="4" class="mb-n4">
                <span class="font-weight-bold text-uppercase">E-mail:</span>
                <p class="font-weight-light title ">
                  {{ usuario.email }}
                </p>
              </v-col>

              <v-col cols="3">
                <v-select
                  v-model="formularioEditor.forma"
                  :items="['PRESENCIAL', 'VIRTUAL']"
                  label="Forma"
                  :rules="[(v) => !!v || 'Tipo da Presença é obrigatória.']"
                  filled
                ></v-select>
              </v-col>

              <v-col cols="4" offset="1" class="mb-n4">
                <span class="font-weight-bold text-uppercase">Data:</span>
                <p class="font-weight-light title ">
                  {{ formularioEditor.data ? formularioEditor.data : this.dataMoment }}
                </p>
              </v-col>

              
              <v-col cols="12" class="mt-n8">
                <v-checkbox
                  v-model="formularioEditor.taxaCambio"
                  label="Taxa de câmbio"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="formularioEditor.conciliacaoBancaria"
                  label="Conciliação Bancária"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="formularioEditor.resumoRubrica"
                  label="Resumo Rubrica"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="formularioEditor.planilhaResumoDespesasEuroEReal"
                  label="Planilhas de resumo de despesas (Euro e Reais)"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="formularioEditor.documentoComprovanteDespesa"
                  label="Documentos comprovantes de despesas"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="formularioEditor.planejamentoFinanceiro"
                  label="Planejamento Financeiro"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="formularioEditor.percentualExecucaoMacroRubrica"
                  label="Percentual de execução de macro rubricas"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="formularioEditor.folhaDedicacaoPessoal"
                  label="Folha de dedicação de Pessoal"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="formularioEditor.frequenciaPessoalProjeto"
                  label="Frequência Pessoal Projeto"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="formularioEditor.pendenciaMesesAnteriores"
                  label="Pendências de meses anteriores"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="formularioEditor.inventario"
                  label="Inventário"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="formularioEditor.contabilidade"
                  label="Contabilidade"
                  hide-details
                ></v-checkbox>
                  <v-checkbox
                    v-model="formularioEditor.outros"
                    label="Outros"
                    hide-details
                  ></v-checkbox>
                  <v-textarea
                    v-model="formularioEditor.outrosItens"
                    :disabled="!formularioEditor.outros"
                    label="Informe outros itens"
                    filled
                    rows="1"
                    auto-grow
                  ></v-textarea>
              </v-col>

              <v-col cols="12" class="mb-n3">
                <v-textarea
                  v-model="formularioEditor.ajustesRealizados"
                    label="Ajustes Realizados"
                    filled
                    rows="2"
                    auto-grow
                ></v-textarea>
              </v-col>

              <v-col cols="12" class="mb-n3">
                <v-textarea
                  v-model="formularioEditor.ajustesSolicitados"
                    label="Ajustes Solicitados"
                    filled
                    rows="2"
                    auto-grow
                ></v-textarea>
              </v-col>

              <v-col cols="12" class="mb-n3">
                <v-textarea
                  v-model="formularioEditor.orientacoes"
                    label="Orientações"
                    filled
                    rows="2"
                    auto-grow
                ></v-textarea>
              </v-col>

              <v-col cols="12" class="mb-n3">
                <v-textarea
                  v-model="formularioEditor.observacoesMonitoramento"
                    label="Observações do Monitoramento"
                    filled
                    rows="3"
                    auto-grow
                ></v-textarea>
              </v-col>

              <v-col v-if="isUpdate" cols="12" class="mt-n4">
                <v-file-input
                  small-chips
                  multiple
                  label="Arquivo"
                  v-model="file"
                ></v-file-input>
              </v-col>
              <v-col v-else cols="12" class="mt-n4">
                <v-file-input
                  small-chips
                  multiple
                  label="Arquivo"
                  v-model="file"
                ></v-file-input>
              </v-col>
            </v-row>

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="mx-1 py-6">
            <v-btn type="submit" color="success text-center" small>{{ isUpdate ? "Salvar alterações" : "Salvar" }}</v-btn>
            <v-btn @click.prevent="cancel" color="error text-center" small>Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
</template>

<script>
import {mapActions} from "vuex";
import moment from 'moment'
moment.locale('pt')

export default {
  props: {
    prestacaoConta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formularioEditor: this.prestacaoConta.monitoramentoFinanceiro ? Object.assign({}, this.prestacaoConta.monitoramentoFinanceiro) : this.formularioEditorReset(),
      valid: true,
      errorMessage: "",
      file: null,
      dataMoment: moment(new Date()).format("DD/MM/YYYY"),
    };
  },
  computed: {
    usuario() {
      return this.$store.getters["usuario/getUser"]
    },
    isUpdate() {
      return !!this.prestacaoConta.monitoramentoFinanceiro;
    },
    titulo() {
      return this.isUpdate ? "Editar Monitoramento Finaceiro" : "Novo Monitoramento Finaceiro" 
    },
  },
  methods: {
    ...mapActions('prestacaoConta', ['criarMonitoramentoFinaceiro', 'editarMonitoramentoFinaceiro']),

    save() {
      if(this.$refs.form.validate()) {
        this.persist().then((formulario) => {
          this.$refs.form.resetValidation()
          this.$emit("save", { formulario });
        })
         .catch((error) => {
           if (error.response) {
             this.errorMessage = error.response.data
           }
         })
      }
    },
    persist() {
      return this.isUpdate ? this.update() : this.create();
    },
    create() {
      const payload = {
        "projetoId": this.prestacaoConta.projeto.id,
        "prestacaoContaId": this.prestacaoConta.id,
        "monitoramentoFinanceiro": {...this.formularioEditor},
        //'file': this.file[0] ? this.file[0] : null 
        'file': Array.isArray(this.file) ? this.file[0] : null 
      }

      return this.criarMonitoramentoFinaceiro(payload)
    },
    update() {
      const payload = {
        "projetoId": this.prestacaoConta.projeto.id,
        "prestacaoContaId": this.prestacaoConta.id,
        "monitoramentoFinanceiro": {...this.formularioEditor},
        //'file': this.file ? this.file[0] : null 
        'file': Array.isArray(this.file) ? this.file[0] : null 
      }

      return this.editarMonitoramentoFinaceiro(payload);
    },
    cancel() {
      this.formularioEditor = this.prestacaoConta.monitoramentoFinanceiro ? Object.assign({}, this.prestacaoConta.monitoramentoFinanceiro) : this.formularioEditorReset(),
      this.$emit("cancel");
    },
    formularioEditorReset() {
      return {};
    },
  },
  created() {
  },  
};
</script>

<style scoped>
</style>
